export const MATRIX_LINK = '/matrix.png';

export const INPUT_MAX_LENGTH = 255;
export const MULTILINE_INPUT_MAX_LENGTH = 1024;
